export const combineVerifications = <T>(
  schemas: (T & { name: string })[],
  _keys: string[][]
): (T | T[])[] => {
  const map = new Map<string, T | T[]>();
  const keys = _keys.map((k) => k.join("-"));

  schemas.forEach((schema) => {
    const match = keys.find((keyArg) => keyArg.includes(schema.name));

    if (!match) {
      return map.set(schema.name, schema);
    }
    if (!map.has(match)) {
      return map.set(match, [schema]);
    }

    const current = map.get(match) as T[];

    if (Array.isArray(current)) {
      return map.set(match, [...current, schema]);
    }

    return map.set(match, [current, schema]);
  });
  return Array.from(map.values());
};
